
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.5 16.965l4.748 3c.749.472 1.673-.231 1.474-1.122l-1.26-5.653 4.195-3.805c.661-.599.308-1.736-.564-1.813l-5.522-.49-2.16-5.335a.973.973 0 00-1.822 0L6.43 7.082l-5.523.49C.036 7.65-.318 8.786.343 9.385l4.195 3.805-1.26 5.653c-.199.891.725 1.594 1.474 1.121l4.748-3z","fill":"#E4EEF7"}})])
          )
        }
      }
    